export const withCacheBust = (url, cacheBust) => {
  if (!url || !cacheBust) return url || "";
  const separator = url.includes("?") ? "&" : "?";
  return `${url}${separator}v=${encodeURIComponent(cacheBust)}`;
};
